import type { GlAccount, GlaGroupedAccounts } from "../types";
import { GlaAccountType } from "../types";
import { getAccountType } from "./filters";

const GLA_SECTION_LABELS: Record<GlaAccountType, string> = {
    [GlaAccountType.UNCATEGORIZED]: "ONGECATEGORISEERD",
    [GlaAccountType.BALANCE_SHEET]: "BALANS",
    [GlaAccountType.PROFIT_AND_LOSS]: "WINST EN VERLIES",
};

export function groupAccounts(accounts: GlAccount[]): GlaGroupedAccounts[] {
    const uncategorizedAccounts: GlAccount[] = [];
    const balanceSheetAccounts: GlAccount[] = [];
    const profitAndLossAccounts: GlAccount[] = [];

    for (const account of accounts) {
        const type = getAccountType(account);
        if (type === GlaAccountType.PROFIT_AND_LOSS) {
            profitAndLossAccounts.push(account);
        } else if (type === GlaAccountType.BALANCE_SHEET) {
            balanceSheetAccounts.push(account);
        } else {
            uncategorizedAccounts.push(account);
        }
    }

    const groups: GlaGroupedAccounts[] = [];

    if (balanceSheetAccounts.length > 0) {
        groups.push({
            type: GlaAccountType.BALANCE_SHEET,
            label: GLA_SECTION_LABELS[GlaAccountType.BALANCE_SHEET],
            accounts: balanceSheetAccounts,
        });
    }

    if (profitAndLossAccounts.length > 0) {
        groups.push({
            type: GlaAccountType.PROFIT_AND_LOSS,
            label: GLA_SECTION_LABELS[GlaAccountType.PROFIT_AND_LOSS],
            accounts: profitAndLossAccounts,
        });
    }

    if (uncategorizedAccounts.length > 0) {
        groups.push({
            type: GlaAccountType.UNCATEGORIZED,
            label: GLA_SECTION_LABELS[GlaAccountType.UNCATEGORIZED],
            accounts: uncategorizedAccounts,
        });
    }

    return groups;
}
